import React, { useEffect, useState } from "react";
import Meta from "./../components/Meta";
import PageLoader from "../components/Loaders/PageLoader";
import { handleRecoverEmail, handleVerifyEmail } from "utilities/auth";
import { useRouter } from "utilities/router";
import { NavLink } from "react-router-dom";
// Sound Commerce branding (no logo image needed)

function FirebaseActionPage(props) {
  const router = useRouter();
  const [formAlert, setFormAlert] = useState(null);
  const [header, setHeader] = useState("");

  useEffect(() => {
    const { mode, oobCode } = router.query;

    // Do nothing if mode param is undefined.
    // Page may have been pre-rendered by server so won't have query values
    // until it's actually run on client (as is the case if using Next.js)
    if (!mode) return;

    // Take action based on Firebase "mode" query param
    switch (mode) {
      case "resetPassword":
        // Redirect to change password page
        router.navigate(`/auth/changepass?oobCode=${oobCode}`);
        break;
      case "recoverEmail":
        // Reset to original email
        handleRecoverEmail(oobCode)
          .then((originalEmail) => {
            setHeader("Recover Email");
            setFormAlert({
              type: "success",
              message: `Your email has been set back to ${originalEmail}. We've also sent you a password reset email so that you can change your password if you think someone may have access to your account.`,
            });
          })
          .catch((error) => {
            setHeader("Recover Email Error");
            setFormAlert({
              type: "error",
              message: error.message,
            });
          });
        break;
      case "verifyEmail":
        // Verify email in Firebase
        handleVerifyEmail(oobCode)
          .then(() => {
            setHeader("Email Verified!");
            setFormAlert({
              type: "success",
              message: `Your email has been verified. You may now close this window.`,
            });
          })
          .catch((error) => {
            setHeader("Unable to Verify Email");
            setFormAlert({
              type: "error",
              message: error.message,
            });
          });
        break;
      default:
        setHeader("An Unexpected Error Occurred");
        setFormAlert({
          type: "error",
          message: "Invalid mode parameter",
        });
    }
  }, [router]);

  return (
    <>
      <Meta title="Firebase Action" />
      <PageLoader>
        <section className="flex items-center h-screen bg-gradient-to-r from-blue-400 via-blue-500 to-indigo-500 px-[20px]">
          <div className="container mx-auto max-w-lg text-center bg-card p-[50px] rounded-[30px] block-shadow">
            <h1 className="mt-4 text-3xl font-bold tracking-tight text-foreground sm:text-5xl">
              {header || "Just a moment"}
            </h1>

            {formAlert && (
              <p
                className={
                  "mt-6 text-base leading-7" +
                  (formAlert.type === "error" ? " text-red-600" : "") +
                  (formAlert.type === "success" ? " text-green-600" : "")
                }
              >
                {formAlert.message}
              </p>
            )}
            {/* SOUND-726: `formAlert` starts as null and is only set by the
                async handler in the effect above — but render runs FIRST, so
                reading `.type` here threw a TypeError on the very first render
                of this page, every time. React unmounts the tree on an uncaught
                render error, so the password-reset "Continue" link landed on a
                dead page. The effect never even ran, meaning the action code
                was never applied either. */}
            <div className="mt-10 flex items-center justify-center gap-x-6">
              {!formAlert ? (
                // Still applying the action code. Previously this frame threw,
                // taking the whole app down with it.
                <span className="text-sm text-muted-foreground">
                  One moment…
                </span>
              ) : formAlert.type === "success" ? (
                <NavLink
                  to="/auth/signin"
                  className="bg-info text-white border-none rounded-[10px] font-medium text-sm px-6 py-3"
                >
                  Log In
                </NavLink>
              ) : (
                <NavLink
                  to="/"
                  className="bg-info text-white border-none rounded-[10px] font-medium text-sm px-6 py-3"
                >
                  Back to Sound Commerce
                </NavLink>
              )}
            </div>
          </div>
        </section>
      </PageLoader>
    </>
  );
}

export default FirebaseActionPage;
